const EnglishAcademy = {
  beranda: 'Home',
  tentangAkademi: 'About Academy',
  visimisi: 'Mission',
  program: 'Programs',
  paket: 'Packages',
  pusatPelatihan: 'Training Center',
  lainnya: 'Other',
};

export default EnglishAcademy